import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  Loader,
} from "@devhop/ui";
import { PackageSearch } from "lucide-react";
import type { BranchProductWithDetails } from "../../domain/types";
import { ProductCard } from "./ProductCard";

type ProductGridProps = {
  products: BranchProductWithDetails[];
  isLoading?: boolean;
  onProductClick: (product: BranchProductWithDetails) => void;
  onProductHover?: (product: BranchProductWithDetails) => void;
  emptyMessage?: string;
};

export function ProductGrid({
  products,
  isLoading = false,
  onProductClick,
  onProductHover,
  emptyMessage = "ບໍ່ພົບສິນຄ້າ",
}: ProductGridProps) {
  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Empty>
          <EmptyHeader>
            <EmptyMedia variant="icon">
              <PackageSearch className="h-8 w-8 text-muted-foreground" />
            </EmptyMedia>
            <EmptyTitle>ບໍ່ພົບສິນຄ້າ</EmptyTitle>
            <EmptyDescription>{emptyMessage}</EmptyDescription>
          </EmptyHeader>
        </Empty>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          onClick={() => onProductClick(product)}
          onHover={() => onProductHover?.(product)}
        />
      ))}
    </div>
  );
}
